import React from 'react';

// ============================================================================
// EmailSentConfirmationModal
// ============================================================================
// Shown after the user clicks "Open in Mail App" from the EmailDraftModal.
// Since the app can't detect whether the email was actually sent in the
// external mail client, this modal asks the user to confirm manually.
//
// Props:
//   stageName    – stage label for context
//   eventType    – email template type (e.g. 'stage_initiated')
//   onConfirmSent – callback when user confirms email was sent
//   onKeepPending – callback when user says "not yet" / keep as pending
//   onClose       – close/cancel (treated same as keep pending)
// ============================================================================

const EVENT_LABELS = {
  project_initiated: 'Project Initiation',
  stage_initiated: 'Stage Initiation',
  stage_completed: 'Stage Completion',
  stage_closure: 'Stage Closure',
  stage_approved: 'Stage Approval',
  invoice_sent: 'Invoice',
  timeline_change: 'Timeline Change',
  reminder_friendly: 'Payment Reminder',
  reminder_overdue: 'Overdue Reminder',
  reminder_final: 'Final Reminder',
};

export default function EmailSentConfirmationModal({ stageName, eventType, onConfirmSent, onKeepPending, onClose }) {
  const label = EVENT_LABELS[eventType] || eventType || 'Email';

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 9999,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(0,0,0,0.35)',
      }}
      onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}
    >
      <div style={{
        background: 'var(--brio-white, #fff)',
        border: '1px solid var(--brio-border)',
        borderRadius: '8px',
        padding: '20px 24px',
        maxWidth: '380px',
        width: '100%',
        fontFamily: 'var(--brio-font-family)',
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
      }}>
        {/* Header */}
        <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '8px' }}>
          Did you send the email?
        </div>

        {/* Context */}
        <div style={{ fontSize: '11px', color: 'var(--brio-grey)', marginBottom: '16px', lineHeight: '1.4' }}>
          {label} email for <strong>{stageName || 'this stage'}</strong> was opened in your mail app.
          Please confirm whether you sent it.
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
          <button
            onClick={() => { if (onKeepPending) onKeepPending(); }}
            style={{
              padding: '6px 14px', fontSize: '11px',
              background: 'transparent', border: '1px solid var(--brio-border)',
              cursor: 'pointer', fontFamily: 'var(--brio-font-family)',
              borderRadius: '4px',
            }}
          >
            No, keep pending
          </button>
          <button
            onClick={() => { if (onConfirmSent) onConfirmSent(); }}
            style={{
              padding: '6px 14px', fontSize: '11px',
              background: 'var(--brio-green, #16a34a)', color: '#fff',
              border: 'none', cursor: 'pointer', fontFamily: 'var(--brio-font-family)',
              borderRadius: '4px', fontWeight: 500,
            }}
          >
            Yes, mark as sent
          </button>
        </div>
      </div>
    </div>
  );
}
